module.exports = __webpack_public_path__ + "static/media/biljonsen.a5bc3e7f.png";